import { Button, Heading, Text } from "@RooUI";
import React from "react";

import { LicenseInformation } from "../../../Common/EditProfile/licenseInformation";
import { FormContainer, FormHeader } from "../Common/styles";
import { ButtonContainer } from "../RegistrationPageContainer/styles";

import { useFormContext } from "./RegistrationLicenseFormContext";

export const RegistrationVetLicenseForm = () => {
  const {
    onChange,
    onSave,
    loading,
    errors,
    // @ts-expect-error TS2339
    form: { licenses, deletedLicenses },
  } = useFormContext();

  return (
    <FormContainer>
      <FormHeader>
        <Heading level={3}>Where can you work?</Heading>
        <Text>Hospitals need your license information to be able to offer shifts.</Text>
      </FormHeader>
      <div>
        <LicenseInformation
          licenses={licenses}
          deletedLicenses={deletedLicenses}
          // @ts-expect-error TS2322
          onChange={onChange}
          hideExpiration
          hideHeader
          hideAddAnotherLicense
          hideClose
          // @ts-expect-error TS18048
          error={errors["licenses"]}
        />
      </div>
      <ButtonContainer>
        <Button
          $buttonType="primary"
          title="Continue"
          onClick={onSave}
          loading={loading}
          data-testid="licenseContinue"
        />
      </ButtonContainer>
    </FormContainer>
  );
};
